import { render, staticRenderFns } from "./EntitySearchAutocomplete.vue?vue&type=template&id=32e395e2&"
import script from "./EntitySearchAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./EntitySearchAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EntitySearchAutocomplete.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports